/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Bookora API
 * API for **bookora.net** — multi-tenant SaaS for Iranian beauty clinics and
 * aesthetic doctors.
 *
 * ## Conventions
 *
 * - **Versioning**: customer-facing routes live under `/api/v1/...`. The health
 *   probes (`/health`, `/ready`) are unprefixed and version-neutral.
 * - **Response envelope**: every successful JSON response is
 *   `{ "data": <payload>, "meta"?: <extra> }`.
 * - **Error envelope**: every error response is
 *   `{ "statusCode": number, "code": string, "message": string, "details"?: any, "requestId"?: string }`.
 *   `code` is a stable token from `ErrorCode`; `message` is finished Persian copy.
 * - **Pagination**: list endpoints take 1-indexed `?page=&pageSize=` and return
 *   `{ items, page, pageSize, total, pageCount }` inside `data`.
 * - **Auth**: bearer JWT. Tokens come from `/api/v1/auth/otp/verify` and rotate on
 *   `/api/v1/auth/refresh`. There are no passwords in this product.
 * - **Tenancy**: the access token carries the clinic. Every tenant-scoped query is
 *   filtered by it server-side; a `clinicId` in a path or body must agree with the
 *   token or the request is rejected.
 * - **Currency**: every money field is an integer in **rials**. Panels display
 *   toman (1 toman = 10 rials).
 * - **Quantities**: integer milli-units (`…Milli`, 1 unit = 1000).
 *   **Percentages**: basis points (`…PercentBp`, 1% = 100).
 * - **Timestamps**: UTC ISO-8601. Jalali conversion happens in the UI.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateDataExportDto,
  CreateErasureRequestDto,
  DataExportDownloadResponse,
  DataExportResponse,
  ErasurePendingCountResponse,
  ErasureRequestResponse,
  PatientErasureList200,
  PatientErasureListParams,
  PatientExportsList200,
  PatientExportsListParams,
  RejectErasureRequestDto
} from '../model';

import { apiClient } from '../../mutator';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * یک کار پس‌زمینه می‌سازد که پروندهٔ کامل بیمار را به شکل ZIP آماده می‌کند: فایل‌های JSON، تصاویر بالینی و PDF رضایت‌نامه‌ها. پاسخ فوری برمی‌گردد و پنل باید وضعیت را با GET بخواند تا READY شود. اگر کلینیک ورود دومرحله‌ای را الزامی کرده باشد، تأیید تازهٔ عامل دوم لازم است.
 * @summary درخواست بستهٔ اطلاعات بیمار
 */
export const patientExportsRequest = (
    createDataExportDto: CreateDataExportDto,
 signal?: AbortSignal
) => {


      return apiClient<DataExportResponse>(
      {url: `/api/v1/patient-exports`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createDataExportDto, signal
    },
      );
    }




export const getPatientExportsRequestMutationKey = () => ['patientExportsRequest'] as const;

export const getPatientExportsRequestMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientExportsRequest>>, TError,PatientExportsRequestMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patientExportsRequest>>, TError,PatientExportsRequestMutationVariables, TContext> => {

const mutationKey = getPatientExportsRequestMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientExportsRequest>>, PatientExportsRequestMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  patientExportsRequest(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatientExportsRequestMutationResult = NonNullable<Awaited<ReturnType<typeof patientExportsRequest>>>
    export type PatientExportsRequestMutationBody = CreateDataExportDto
    export type PatientExportsRequestMutationError = void
    export type PatientExportsRequestMutationVariables = {data: CreateDataExportDto}

    /**
 * @summary درخواست بستهٔ اطلاعات بیمار
 */
export const usePatientExportsRequest = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientExportsRequest>>, TError,PatientExportsRequestMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patientExportsRequest>>,
        TError,
        PatientExportsRequestMutationVariables,
        TContext
      > => {
      return useMutation(getPatientExportsRequestMutationOptions(options), queryClient);
    }
    /**
 * درخواست‌های خروجی کلینیک، تازه‌ترین اول. با patientId می‌توان به یک بیمار محدود کرد.
 * @summary فهرست بسته‌های اطلاعات
 */
export const patientExportsList = (
    params?: PatientExportsListParams,
 signal?: AbortSignal
) => {


      return apiClient<PatientExportsList200>(
      {url: `/api/v1/patient-exports`, method: 'GET',
        params, signal
    },
      );
    }




export const getPatientExportsListQueryKey = (params?: PatientExportsListParams,) => {
    return [
    `/api/v1/patient-exports`, ...(params ? [params] : [])
    ] as const;
    }


export const getPatientExportsListQueryOptions = <TData = Awaited<ReturnType<typeof patientExportsList>>, TError = unknown>(params?: PatientExportsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientExportsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientExportsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientExportsList>>> = ({ signal }) => patientExportsList(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientExportsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PatientExportsListQueryResult = NonNullable<Awaited<ReturnType<typeof patientExportsList>>>
export type PatientExportsListQueryError = unknown


export function usePatientExportsList<TData = Awaited<ReturnType<typeof patientExportsList>>, TError = unknown>(
 params: undefined |  PatientExportsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientExportsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientExportsList>>,
          TError,
          Awaited<ReturnType<typeof patientExportsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientExportsList<TData = Awaited<ReturnType<typeof patientExportsList>>, TError = unknown>(
 params?: PatientExportsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientExportsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientExportsList>>,
          TError,
          Awaited<ReturnType<typeof patientExportsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientExportsList<TData = Awaited<ReturnType<typeof patientExportsList>>, TError = unknown>(
 params?: PatientExportsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientExportsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary فهرست بسته‌های اطلاعات
 */

export function usePatientExportsList<TData = Awaited<ReturnType<typeof patientExportsList>>, TError = unknown>(
 params?: PatientExportsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientExportsList>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPatientExportsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * یک کار پس‌زمینه می‌سازد که همهٔ پرونده‌های کلینیک (همراه با سطل بازیافت) را با رضایت‌نامه‌ها و تصاویر در یک فایل ZIP آماده می‌کند. فقط مالک کلینیک. هر ۲۴ ساعت یک درخواست و در هر لحظه یک بستهٔ در حال ساخت. پیشرفت در progress همین ردیف خوانده می‌شود.
 * @summary درخواست خروجی کامل کلینیک
 */
export const patientExportsRequestClinic = (

 signal?: AbortSignal
) => {


      return apiClient<DataExportResponse>(
      {url: `/api/v1/patient-exports/clinic`, method: 'POST', signal
    },
      );
    }




export const getPatientExportsRequestClinicMutationKey = () => ['patientExportsRequestClinic'] as const;

export const getPatientExportsRequestClinicMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientExportsRequestClinic>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patientExportsRequestClinic>>, TError,void, TContext> => {

const mutationKey = getPatientExportsRequestClinicMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientExportsRequestClinic>>, void> = () => {


          return  patientExportsRequestClinic()
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatientExportsRequestClinicMutationResult = NonNullable<Awaited<ReturnType<typeof patientExportsRequestClinic>>>

    export type PatientExportsRequestClinicMutationError = void


    /**
 * @summary درخواست خروجی کامل کلینیک
 */
export const usePatientExportsRequestClinic = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientExportsRequestClinic>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patientExportsRequestClinic>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getPatientExportsRequestClinicMutationOptions(options), queryClient);
    }
    /**
 * PENDING در صف، PROCESSING در حال ساخت، READY آمادهٔ دانلود، FAILED با متن خطا، EXPIRED پس از پایان مهلت نگهداری فایل.
 * @summary وضعیت یک بستهٔ اطلاعات
 */
export const patientExportsFindOne = (
    id: string,
 signal?: AbortSignal
) => {


      return apiClient<DataExportResponse>(
      {url: `/api/v1/patient-exports/${id}`, method: 'GET', signal
    },
      );
    }




export const getPatientExportsFindOneQueryKey = (id: string,) => {
    return [
    `/api/v1/patient-exports/${id}`
    ] as const;
    }


export const getPatientExportsFindOneQueryOptions = <TData = Awaited<ReturnType<typeof patientExportsFindOne>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientExportsFindOne>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientExportsFindOneQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientExportsFindOne>>> = ({ signal }) => patientExportsFindOne(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientExportsFindOne>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PatientExportsFindOneQueryResult = NonNullable<Awaited<ReturnType<typeof patientExportsFindOne>>>
export type PatientExportsFindOneQueryError = void


export function usePatientExportsFindOne<TData = Awaited<ReturnType<typeof patientExportsFindOne>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientExportsFindOne>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientExportsFindOne>>,
          TError,
          Awaited<ReturnType<typeof patientExportsFindOne>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientExportsFindOne<TData = Awaited<ReturnType<typeof patientExportsFindOne>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientExportsFindOne>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientExportsFindOne>>,
          TError,
          Awaited<ReturnType<typeof patientExportsFindOne>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientExportsFindOne<TData = Awaited<ReturnType<typeof patientExportsFindOne>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientExportsFindOne>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary وضعیت یک بستهٔ اطلاعات
 */

export function usePatientExportsFindOne<TData = Awaited<ReturnType<typeof patientExportsFindOne>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientExportsFindOne>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPatientExportsFindOneQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * یک نشانی امضاشدهٔ کوتاه‌عمر (حداکثر ۵ دقیقه) برمی‌گرداند. نشانی مستقیم فایل هرگز دائمی نیست؛ اگر آن را جایی بفرستید تا رسیدنش منقضی شده است.
 * @summary دریافت نشانی دانلود بسته
 */
export const patientExportsDownload = (
    id: string,
 signal?: AbortSignal
) => {


      return apiClient<DataExportDownloadResponse>(
      {url: `/api/v1/patient-exports/${id}/download`, method: 'GET', signal
    },
      );
    }




export const getPatientExportsDownloadQueryKey = (id: string,) => {
    return [
    `/api/v1/patient-exports/${id}/download`
    ] as const;
    }


export const getPatientExportsDownloadQueryOptions = <TData = Awaited<ReturnType<typeof patientExportsDownload>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientExportsDownload>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientExportsDownloadQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientExportsDownload>>> = ({ signal }) => patientExportsDownload(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientExportsDownload>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PatientExportsDownloadQueryResult = NonNullable<Awaited<ReturnType<typeof patientExportsDownload>>>
export type PatientExportsDownloadQueryError = void


export function usePatientExportsDownload<TData = Awaited<ReturnType<typeof patientExportsDownload>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientExportsDownload>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientExportsDownload>>,
          TError,
          Awaited<ReturnType<typeof patientExportsDownload>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientExportsDownload<TData = Awaited<ReturnType<typeof patientExportsDownload>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientExportsDownload>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientExportsDownload>>,
          TError,
          Awaited<ReturnType<typeof patientExportsDownload>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientExportsDownload<TData = Awaited<ReturnType<typeof patientExportsDownload>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientExportsDownload>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary دریافت نشانی دانلود بسته
 */

export function usePatientExportsDownload<TData = Awaited<ReturnType<typeof patientExportsDownload>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientExportsDownload>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPatientExportsDownloadQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * درخواست را در وضعیت «در انتظار بررسی» ثبت می‌کند. هیچ چیزی در این مرحله حذف نمی‌شود؛ حذف واقعی پس از تأیید و پس از پایان مهلت نگهداری کلینیک انجام می‌شود و برگشت‌پذیر نیست.
 * @summary ثبت درخواست حذف اطلاعات بیمار
 */
export const patientErasureRequest = (
    createErasureRequestDto: CreateErasureRequestDto,
 signal?: AbortSignal
) => {


      return apiClient<ErasureRequestResponse>(
      {url: `/api/v1/patient-erasure-requests`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createErasureRequestDto, signal
    },
      );
    }




export const getPatientErasureRequestMutationKey = () => ['patientErasureRequest'] as const;

export const getPatientErasureRequestMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientErasureRequest>>, TError,PatientErasureRequestMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patientErasureRequest>>, TError,PatientErasureRequestMutationVariables, TContext> => {

const mutationKey = getPatientErasureRequestMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientErasureRequest>>, PatientErasureRequestMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  patientErasureRequest(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatientErasureRequestMutationResult = NonNullable<Awaited<ReturnType<typeof patientErasureRequest>>>
    export type PatientErasureRequestMutationBody = CreateErasureRequestDto
    export type PatientErasureRequestMutationError = void
    export type PatientErasureRequestMutationVariables = {data: CreateErasureRequestDto}

    /**
 * @summary ثبت درخواست حذف اطلاعات بیمار
 */
export const usePatientErasureRequest = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientErasureRequest>>, TError,PatientErasureRequestMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patientErasureRequest>>,
        TError,
        PatientErasureRequestMutationVariables,
        TContext
      > => {
      return useMutation(getPatientErasureRequestMutationOptions(options), queryClient);
    }
    /**
 * @summary فهرست درخواست‌های حذف اطلاعات
 */
export const patientErasureList = (
    params?: PatientErasureListParams,
 signal?: AbortSignal
) => {


      return apiClient<PatientErasureList200>(
      {url: `/api/v1/patient-erasure-requests`, method: 'GET',
        params, signal
    },
      );
    }




export const getPatientErasureListQueryKey = (params?: PatientErasureListParams,) => {
    return [
    `/api/v1/patient-erasure-requests`, ...(params ? [params] : [])
    ] as const;
    }


export const getPatientErasureListQueryOptions = <TData = Awaited<ReturnType<typeof patientErasureList>>, TError = unknown>(params?: PatientErasureListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientErasureList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientErasureListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientErasureList>>> = ({ signal }) => patientErasureList(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientErasureList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PatientErasureListQueryResult = NonNullable<Awaited<ReturnType<typeof patientErasureList>>>
export type PatientErasureListQueryError = unknown


export function usePatientErasureList<TData = Awaited<ReturnType<typeof patientErasureList>>, TError = unknown>(
 params: undefined |  PatientErasureListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientErasureList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientErasureList>>,
          TError,
          Awaited<ReturnType<typeof patientErasureList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientErasureList<TData = Awaited<ReturnType<typeof patientErasureList>>, TError = unknown>(
 params?: PatientErasureListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientErasureList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientErasureList>>,
          TError,
          Awaited<ReturnType<typeof patientErasureList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientErasureList<TData = Awaited<ReturnType<typeof patientErasureList>>, TError = unknown>(
 params?: PatientErasureListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientErasureList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary فهرست درخواست‌های حذف اطلاعات
 */

export function usePatientErasureList<TData = Awaited<ReturnType<typeof patientErasureList>>, TError = unknown>(
 params?: PatientErasureListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientErasureList>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPatientErasureListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * برای نشان روی زبانهٔ حریم خصوصی: چند درخواست حذف اطلاعات منتظر تأیید یا رد است، بدون بارگذاری خود فهرست.
 * @summary تعداد درخواست‌های حذف در انتظار بررسی
 */
export const patientErasurePendingCount = (

 signal?: AbortSignal
) => {


      return apiClient<ErasurePendingCountResponse>(
      {url: `/api/v1/patient-erasure-requests/pending-count`, method: 'GET', signal
    },
      );
    }




export const getPatientErasurePendingCountQueryKey = () => {
    return [
    `/api/v1/patient-erasure-requests/pending-count`
    ] as const;
    }


export const getPatientErasurePendingCountQueryOptions = <TData = Awaited<ReturnType<typeof patientErasurePendingCount>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientErasurePendingCount>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientErasurePendingCountQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientErasurePendingCount>>> = ({ signal }) => patientErasurePendingCount(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientErasurePendingCount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PatientErasurePendingCountQueryResult = NonNullable<Awaited<ReturnType<typeof patientErasurePendingCount>>>
export type PatientErasurePendingCountQueryError = void


export function usePatientErasurePendingCount<TData = Awaited<ReturnType<typeof patientErasurePendingCount>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientErasurePendingCount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientErasurePendingCount>>,
          TError,
          Awaited<ReturnType<typeof patientErasurePendingCount>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientErasurePendingCount<TData = Awaited<ReturnType<typeof patientErasurePendingCount>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientErasurePendingCount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientErasurePendingCount>>,
          TError,
          Awaited<ReturnType<typeof patientErasurePendingCount>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientErasurePendingCount<TData = Awaited<ReturnType<typeof patientErasurePendingCount>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientErasurePendingCount>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary تعداد درخواست‌های حذف در انتظار بررسی
 */

export function usePatientErasurePendingCount<TData = Awaited<ReturnType<typeof patientErasurePendingCount>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientErasurePendingCount>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPatientErasurePendingCountQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary یک درخواست حذف اطلاعات
 */
export const patientErasureFindOne = (
    id: string,
 signal?: AbortSignal
) => {


      return apiClient<ErasureRequestResponse>(
      {url: `/api/v1/patient-erasure-requests/${id}`, method: 'GET', signal
    },
      );
    }




export const getPatientErasureFindOneQueryKey = (id: string,) => {
    return [
    `/api/v1/patient-erasure-requests/${id}`
    ] as const;
    }


export const getPatientErasureFindOneQueryOptions = <TData = Awaited<ReturnType<typeof patientErasureFindOne>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientErasureFindOne>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientErasureFindOneQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientErasureFindOne>>> = ({ signal }) => patientErasureFindOne(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientErasureFindOne>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PatientErasureFindOneQueryResult = NonNullable<Awaited<ReturnType<typeof patientErasureFindOne>>>
export type PatientErasureFindOneQueryError = void


export function usePatientErasureFindOne<TData = Awaited<ReturnType<typeof patientErasureFindOne>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientErasureFindOne>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientErasureFindOne>>,
          TError,
          Awaited<ReturnType<typeof patientErasureFindOne>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientErasureFindOne<TData = Awaited<ReturnType<typeof patientErasureFindOne>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientErasureFindOne>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientErasureFindOne>>,
          TError,
          Awaited<ReturnType<typeof patientErasureFindOne>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientErasureFindOne<TData = Awaited<ReturnType<typeof patientErasureFindOne>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientErasureFindOne>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary یک درخواست حذف اطلاعات
 */

export function usePatientErasureFindOne<TData = Awaited<ReturnType<typeof patientErasureFindOne>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientErasureFindOne>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPatientErasureFindOneQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * پرونده بلافاصله به سطل بازیافت می‌رود و زمان پاک‌سازی نهایی بر اساس مهلت نگهداری کلینیک تعیین می‌شود. تأییدکننده باید فردی غیر از ثبت‌کننده باشد، مگر آنکه کلینیک فقط یک کارمند فعال داشته باشد. اگر کلینیک ورود دومرحله‌ای را الزامی کرده باشد، تأیید تازهٔ عامل دوم لازم است.
 * @summary تأیید درخواست حذف اطلاعات
 */
export const patientErasureApprove = (
    id: string,
 signal?: AbortSignal
) => {


      return apiClient<ErasureRequestResponse>(
      {url: `/api/v1/patient-erasure-requests/${id}/approve`, method: 'POST', signal
    },
      );
    }




export const getPatientErasureApproveMutationKey = () => ['patientErasureApprove'] as const;

export const getPatientErasureApproveMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientErasureApprove>>, TError,PatientErasureApproveMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patientErasureApprove>>, TError,PatientErasureApproveMutationVariables, TContext> => {

const mutationKey = getPatientErasureApproveMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientErasureApprove>>, PatientErasureApproveMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  patientErasureApprove(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatientErasureApproveMutationResult = NonNullable<Awaited<ReturnType<typeof patientErasureApprove>>>

    export type PatientErasureApproveMutationError = void
    export type PatientErasureApproveMutationVariables = {id: string}

    /**
 * @summary تأیید درخواست حذف اطلاعات
 */
export const usePatientErasureApprove = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientErasureApprove>>, TError,PatientErasureApproveMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patientErasureApprove>>,
        TError,
        PatientErasureApproveMutationVariables,
        TContext
      > => {
      return useMutation(getPatientErasureApproveMutationOptions(options), queryClient);
    }
    /**
 * پاک‌سازی زمان‌بندی‌شده لغو می‌شود. دلیل رد برای بیمار قابل استناد است، پس آن را روشن بنویسید.
 * @summary رد درخواست حذف اطلاعات
 */
export const patientErasureReject = (
    id: string,
    rejectErasureRequestDto: RejectErasureRequestDto,
 signal?: AbortSignal
) => {


      return apiClient<ErasureRequestResponse>(
      {url: `/api/v1/patient-erasure-requests/${id}/reject`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rejectErasureRequestDto, signal
    },
      );
    }




export const getPatientErasureRejectMutationKey = () => ['patientErasureReject'] as const;

export const getPatientErasureRejectMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientErasureReject>>, TError,PatientErasureRejectMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patientErasureReject>>, TError,PatientErasureRejectMutationVariables, TContext> => {

const mutationKey = getPatientErasureRejectMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientErasureReject>>, PatientErasureRejectMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  patientErasureReject(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatientErasureRejectMutationResult = NonNullable<Awaited<ReturnType<typeof patientErasureReject>>>
    export type PatientErasureRejectMutationBody = RejectErasureRequestDto
    export type PatientErasureRejectMutationError = void
    export type PatientErasureRejectMutationVariables = {id: string;data: RejectErasureRequestDto}

    /**
 * @summary رد درخواست حذف اطلاعات
 */
export const usePatientErasureReject = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientErasureReject>>, TError,PatientErasureRejectMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patientErasureReject>>,
        TError,
        PatientErasureRejectMutationVariables,
        TContext
      > => {
      return useMutation(getPatientErasureRejectMutationOptions(options), queryClient);
    }
